import * as actionCreatorFactory from "typescript-fsa";
import { Action } from "typescript-fsa";

import { StateError, NormalisedResult } from "@orm/models";
import * as actionTypes from "../constants";
import { ChartsNormalisedEntities } from "../models";

const actionCreator = actionCreatorFactory.default();

export const requestChartsIndex = actionCreator<{}>(actionTypes.INDEX_REQUEST);
export const chartsIndexSuccess = actionCreator<NormalisedResult<string[], ChartsNormalisedEntities>>(
    actionTypes.INDEX_SUCCESS,
);
export const chartsIndexFailure = actionCreator<StateError>(actionTypes.INDEX_FAILURE);

export type ChartsAction = Action<{}> | Action<StateError> |
    Action<NormalisedResult<string[], ChartsNormalisedEntities>>;
